/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from "react-dom";
import '../css/InputField.css';

class InputField extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			type : this.props.type,
			className : this.props.className,
			dataField : this.props.dataField,
			value : this.props.value,
			placeholder: this.props.placeholder
		};
		this.onChange = this.onChange.bind(this);
		this.beforeOnChange = this.beforeOnChange.bind(this);
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({type:nextProps.type, className:nextProps.className, value:nextProps.value,placeholder:nextProps.placeholder});
	} 
	
	beforeOnChange(value,e){
		return value;
	}

	onChange(e){
		var stringValue = e.target.value;
		stringValue = this.beforeOnChange(stringValue,e);
		this.props.parent.setState({[this.props.dataField]:stringValue});
	}


	

	render() {
		return (
			<React.Fragment>
					
				<input autoComplete="nope" value={this.props.value || ''} type={this.state.type} className={this.state.className} maxLength={this.props.maxLength} 
					onChange={this.onChange}  placeholder={this.props.placeholder} />		
					
			</React.Fragment>			
		);
	}
}



export default InputField;